import { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { getCallNumber, getPhoneNumber } from '../utils';
import {
  renderFax,
  renderFaxDate,
  renderFlagMessage,
  renderFullName,
  renderLastCallDate,
  renderNextCallDate,
  renderPhone,
  renderSpeciality,
} from './FormElements';
import ActionSelect from './ActionSelect';
import AdditionalInfoForm from './AdditionalInfoForm';
import CustomFormForm from './CustomFormForm';
import MetaSpecialtiesForm from './MetaSpecialtiesForm';
import MetaTagsForm from './MetaTagsForm';
import ProceduresForm from './ProceduresForm';
import WaitTimeForm from './WaitTimeForm';
import WaitTimeMsgForm from './WaitTimeMsgForm';
import { EmptySpecialityOption } from '../config';
import '../styles/SearchCard.css';
import PhoneForm from './PhoneForm';
import StandardSelect from './StandardSelect';
import StandardTextInput from './StandardTextInput';

interface SearchCardProps {
  groupDataType: any;
  selectedGroupData: any;
  isSavingGroupData: any;
  setIsSavingGroupData: any;
  dispatch: any;
  schedules: any;
  procedureList: any;
  admins: any;
  setShowFlagModal: any;
  sdMetaInfo: any;
  setSDMetaInfo: any;
  sdExtraInfo: any;
  setSDExtraInfo: any;
  sdImpExtraInfo: any;
  setSDImpExtraInfo: any;
  eventsMap: any;
  setShowFullCardModal: any;
  sdProcedures: any;
  setSDProcedures: any;
  disableEdits: any;
  sdWaitTimeStart: any;
  setSDWaitTimeStart: any;
  sdWaitTimeEnd: any;
  setSDWaitTimeEnd: any;
  sdWaitTimeUnit: any;
  setSDWaitTimeUnit: any;
  actionOptions: any;
  setActionOptions: any;
  actionValue: any;
  setActionValue: any;
  doctors: any;
  selectedGroupDataType: any;
  sdMetaSpecialties: any;
  setSDMetaSpecialties: any;
  adminMode: any;
  sdWaitTimeMsg: any;
  setSDWaitTimeMsg: any;
  sdFinalExtraInfo: any;
  setSDFinalExtraInfo: any;
  sdCustomForm: any;
  setSDCustomForm: any;
  allProcedureOptions: any;
  sdSearchSpecialties: any;
  setSDSearchSpecialties: any;
  allSpecialityOptions: any;
  sdPhone: any;
  setSDPhone: any;
  sdPhoneExt: any;
  setSDPhoneExt: any;
  sdFax: any;
  setSDFax: any;
  sdFaxExt: any;
  setSDFaxExt: any;
  editPhoneFax: any;
  setEditPhoneFax: any;
}

function SearchCard(props: SearchCardProps) {
  // Form Control
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  useEffect(() => {
    clearMsgs();
  }, [props.selectedGroupData]);

  const clearMsgs = () => {
    if (errorMsg !== '') {
      setErrorMsg('');
    }
    if (successMsg !== '') {
      setSuccessMsg('');
    }
  };

  const renderSearchData = () => {
    if (
      props.selectedGroupData &&
      props.groupDataType === 'search' &&
      props.selectedGroupDataType === 'search-doctor'
    ) {
      const selectedDoctor = props.selectedGroupData;
      const selectedDoctorAdmin = props.admins.find(
        (doctor: any) => doctor['cpsoNum'] === props.selectedGroupData['cpsoNum'],
      );

      const selectedDoctorSchedule = props.schedules.find(
        (schedule: any) => schedule['scheduleId'] === props.selectedGroupData['scheduleId'],
      );

      const allEdits =
        props.adminMode &&
        (props.selectedGroupDataType === 'search-doctor' ||
          props.selectedGroupDataType === 'additionalinfo-doctor' ||
          props.selectedGroupDataType === 'impadditionalinfo-doctor');

      const disableWaitTimeEdits =
        props.adminMode &&
        (props.selectedGroupDataType === 'additionalinfo-doctor' ||
          props.selectedGroupDataType === 'impadditionalinfo-doctor' ||
          props.selectedGroupDataType === 'search-doctor');

      return (
        <Container className="searchCardContainer">
          {selectedDoctor['hideCard'] && (
            <Alert variant={'warning'}>
              <b>Note:</b> This doctor is hidden!
            </Alert>
          )}
          {!selectedDoctorAdmin['active'] && (
            <Alert variant={'danger'}>
              <b>Note:</b> This doctor has been removed!
            </Alert>
          )}
          {selectedDoctor['isUpdateCall'] && selectedDoctor['nextCallDate'] != null && (
            <Row>{renderNextCallDate(selectedDoctor['nextCallDate'])}</Row>
          )}
          {selectedDoctor['isUpdateCall'] && selectedDoctor['lastCallDate'] != null && (
            <Row>{renderLastCallDate(selectedDoctor['lastCallDate'])}</Row>
          )}
          {selectedDoctorSchedule && selectedDoctorSchedule['flagMsg'] != null && (
            <Row>{renderFlagMessage(selectedDoctorSchedule['flagMsg'])}</Row>
          )}
          {selectedDoctorSchedule && selectedDoctorSchedule['faxDate'] != null && (
            <Row>{renderFaxDate(selectedDoctorSchedule['faxDate'])}</Row>
          )}
          <Row>
            {renderFullName(selectedDoctor['fullName'])}
            <StandardTextInput
              label="City"
              textValue={
                selectedDoctor['location'] == null || selectedDoctor['location'] === undefined
                  ? ''
                  : selectedDoctor['location']['city']
              }
              setTextValue={() => null}
              clearMsgs={clearMsgs}
              disabled={true}
            />
            {renderPhone(
              getPhoneNumber(props.sdPhone, props.sdPhoneExt),
              getCallNumber(selectedDoctorSchedule),
              selectedDoctor['location'] !== null && selectedDoctor['location'] !== undefined
                ? selectedDoctor['location']['city']
                : '',
              true,
              props.editPhoneFax,
              props.setEditPhoneFax,
              props.disableEdits,
            )}
            {renderFax(
              getPhoneNumber(props.sdFax, props.sdFaxExt),
              props.editPhoneFax,
              props.setEditPhoneFax,
              props.disableEdits,
            )}
          </Row>
          {props.editPhoneFax && (
            <Row>
              <PhoneForm
                phoneLabel="Phone"
                phoneStr={props.sdPhone}
                setPhoneStr={props.setSDPhone}
                phoneExtStr={props.sdPhoneExt}
                setPhoneExtStr={props.setSDPhoneExt}
                disabled={props.disableEdits()}
              />
              <PhoneForm
                phoneLabel="Fax"
                phoneStr={props.sdFax}
                setPhoneStr={props.setSDFax}
                phoneExtStr={props.sdFaxExt}
                setPhoneExtStr={props.setSDFaxExt}
                disabled={props.disableEdits()}
              />
            </Row>
          )}
          <Row>
            {renderSpeciality(selectedDoctor['specialties'], true)}
            <ProceduresForm
              procedureValue={props.sdProcedures}
              setProcedureValue={props.setSDProcedures}
              disable={props.disableEdits}
              hasInternalMedicine={selectedDoctor['specialties'].includes('Internal Medicine')}
              selectedSpecialties={
                selectedDoctor
                  ? selectedDoctor['specialties'].concat(selectedDoctor['searchSpecialties'])
                  : null
              }
              procedureList={props.procedureList}
              clearMsgs={clearMsgs}
              allProcedureOptions={props.allProcedureOptions}
              adminMode={props.adminMode}
            />
          </Row>
          {props.adminMode && allEdits && (
            <Row>
              <StandardSelect
                label={'Search Specialities'}
                selectValue={props.sdSearchSpecialties}
                setSelectValue={props.setSDSearchSpecialties}
                selectOptions={props.allSpecialityOptions}
                selectType={EmptySpecialityOption}
                disable={() => props.disableEdits()}
                clearMsgs={clearMsgs}
                isMulti={true}
              />
            </Row>
          )}
          <Row>
            <WaitTimeForm
              waitTimeStartValue={props.sdWaitTimeStart}
              setWaitTimeStartValue={props.setSDWaitTimeStart}
              waitTimeEndValue={props.sdWaitTimeEnd}
              setWaitTimeEndValue={props.setSDWaitTimeEnd}
              waitTimeUnitValue={props.sdWaitTimeUnit}
              setWaitTimeUnitValue={props.setSDWaitTimeUnit}
              disable={() => disableWaitTimeEdits || props.disableEdits()}
              selectedGroupData={props.selectedGroupData}
              clearMsgs={clearMsgs}
              isAdminMode={props.adminMode}
            />
            {props.adminMode && (
              <WaitTimeMsgForm
                waitTimeMsgValue={props.sdWaitTimeMsg}
                setWaitTimeMsgValue={props.setSDWaitTimeMsg}
                disable={() => disableWaitTimeEdits || props.disableEdits()}
                selectedGroupData={props.selectedGroupData}
                clearMsgs={clearMsgs}
              />
            )}
            {!props.adminMode && (
              <MetaTagsForm
                metaTagsValue={props.sdMetaInfo}
                setMetaTagsValue={props.setSDMetaInfo}
                disable={() => disableWaitTimeEdits || props.disableEdits()}
                selectedGroupData={props.selectedGroupData}
                clearMsgs={clearMsgs}
                sdExtraInfo={props.sdExtraInfo}
                setSDExtraInfo={props.setSDExtraInfo}
              />
            )}
          </Row>
          {allEdits && (
            <Row>
              <MetaSpecialtiesForm
                metaSpecialtiesValue={props.sdMetaSpecialties}
                setMetaSpecialtiesValue={props.setSDMetaSpecialties}
                disable={props.disableEdits}
                clearMsgs={clearMsgs}
              />
              <MetaTagsForm
                metaTagsValue={props.sdMetaInfo}
                setMetaTagsValue={props.setSDMetaInfo}
                disable={() => disableWaitTimeEdits || props.disableEdits()}
                selectedGroupData={props.selectedGroupData}
                clearMsgs={clearMsgs}
                sdExtraInfo={props.sdExtraInfo}
                setSDExtraInfo={props.setSDExtraInfo}
              />
            </Row>
          )}
          <Row>
            <AdditionalInfoForm
              extraInfoValue={props.sdImpExtraInfo}
              setExtraInfoValue={props.setSDImpExtraInfo}
              disable={props.adminMode ? () => true : props.disableEdits}
              selectedGroupData={props.selectedGroupData}
              clearMsgs={clearMsgs}
              headerLabel={'Important Additional Information'}
            />
          </Row>
          <Row>
            <AdditionalInfoForm
              extraInfoValue={props.sdExtraInfo}
              setExtraInfoValue={props.setSDExtraInfo}
              disable={props.adminMode ? () => true : () => props.disableEdits()}
              selectedGroupData={props.selectedGroupData}
              clearMsgs={clearMsgs}
              headerLabel={'Other Additional Information'}
            />
          </Row>
          <Row>
            <AdditionalInfoForm
              extraInfoValue={props.sdFinalExtraInfo}
              setExtraInfoValue={props.setSDFinalExtraInfo}
              disable={props.adminMode ? () => props.disableEdits() : () => true}
              selectedGroupData={props.selectedGroupData}
              clearMsgs={clearMsgs}
              headerLabel={'Final Additional Information'}
            />
          </Row>
          <Row>
            <CustomFormForm
              customFormValue={props.sdCustomForm}
              setCustomFormValue={props.setSDCustomForm}
              disable={props.disableEdits}
              selectedGroupData={props.selectedGroupData}
              clearMsgs={clearMsgs}
            />
          </Row>
          <Row>
            <Col md="2">
              <Button
                variant="outline-secondary"
                onClick={() => props.setShowFullCardModal(true)}
                disabled={props.disableEdits()}
              >
                Expand
              </Button>
            </Col>
            <Col className="previewButtonGroup" md="10">
              {props.isSavingGroupData && <Spinner animation="border" className="loadingSpinner" />}
              <ActionSelect
                actionValue={props.actionValue}
                setActionValue={props.setActionValue}
                disableEdits={props.disableEdits}
                clearMsgs={clearMsgs}
                actionOptions={props.actionOptions}
                sdMetaInfo={props.sdMetaInfo}
                setIsSavingGroupData={props.setIsSavingGroupData}
                setErrorMsg={setErrorMsg}
                dispatch={props.dispatch}
                selectedGroupData={props.selectedGroupData}
                admins={props.admins}
                schedules={props.schedules}
                eventsMap={props.eventsMap}
                sdExtraInfo={props.sdExtraInfo}
                sdImpExtraInfo={props.sdImpExtraInfo}
                sdWaitTimeStart={props.sdWaitTimeStart}
                sdWaitTimeEnd={props.sdWaitTimeEnd}
                sdWaitTimeUnit={props.sdWaitTimeUnit}
                sdProcedures={props.sdProcedures}
                setShowFlagModal={props.setShowFlagModal}
                selectedGroupDataType={props.selectedGroupDataType}
                sdWaitTimeMsg={props.sdWaitTimeMsg}
                sdMetaSpecialties={props.sdMetaSpecialties}
                sdSearchSpecialties={props.sdSearchSpecialties}
                sdFinalExtraInfo={props.sdFinalExtraInfo}
                sdCustomForm={props.sdCustomForm}
                adminMode={props.adminMode}
                groupDataType={props.groupDataType}
                sdPhone={props.sdPhone}
                sdPhoneExt={props.sdPhoneExt}
                sdFax={props.sdFax}
                sdFaxExt={props.sdFaxExt}
              />
            </Col>
          </Row>
          <Row>
            <Col className="previewButtonGroup">
              <p className="successMsg">{successMsg}</p>
              <p className="errorMsg">{errorMsg}</p>
            </Col>
          </Row>
        </Container>
      );
    } else {
      return null;
    }
  };

  return renderSearchData();
}

export default SearchCard;
